import { normalize } from "./normalizeString";

const escapeRegExp = (string: string): string => {
  return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
};

export const regexify = (searchTerm: string): RegExp => {
  // Parentheses should not make an otherwise matching POI disappear. Build
  // from original characters so regex escape sequences cannot be split apart.
  const characters = Array.from(normalize(searchTerm).replace(/[()]/g, ""));
  if (!characters.length) return /(?!)/gi;
  const pattern = characters
    .map((character) => `(?:${escapeRegExp(character)}|[^a-zA-Z0-9])`)
    .join("[^a-zA-Z0-9]?");
  return new RegExp(pattern, "gi");
};
